import { start } from './guest-questionnaire.jsx';

if (!window.MATERIO_UNSUPPORTED_BROWSER_DETECTED) {
  start();
}
